"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var scenario_node_view_styles_1 = require("../scenario-node-view/scenario-node-view.styles");

var styled_components_1 = require("styled-components");

var greeting_scenario_node_styles_1 = require("./greeting-scenario-node.styles");

var greeting_scenario_node_component_1 = require("./greeting-scenario-node.component");

var greeting_scenario_node_footer_button_container_1 = __importDefault(require("../scenario-node-footer-button-box/greeting-scenario-node-footer-button.container"));

var GreetingScenarioNodeTemplate = function GreetingScenarioNodeTemplate(_ref) {
  var node = _ref.node,
      _ref$design = _ref.design,
      bodyBackColor = _ref$design.bodyBackColor,
      bodyTextColor = _ref$design.bodyTextColor,
      footerBackColor = _ref$design.footerBackColor,
      _ref$scale = _ref.scale,
      scale = _ref$scale === void 0 ? 1 : _ref$scale,
      headerButton = _ref.headerButton,
      footerButton = _ref.footerButton;
  var header = node.header,
      waitingTime = node.waitingTime,
      openingTimes = node.openingTimes,
      timeTable = node.timeTable;
  return react_1.default.createElement(styled_components_1.ThemeProvider, {
    theme: scenario_node_view_styles_1.initNodeTheme(scale)
  }, react_1.default.createElement(greeting_scenario_node_styles_1.StyledGreetingNodeDiv, null, react_1.default.createElement(greeting_scenario_node_styles_1.StyledGreetingNodeHeaderDiv, {
    backgroundColor: bodyBackColor
  }, react_1.default.createElement(greeting_scenario_node_styles_1.StyledGreetingMessagePre, {
    color: bodyTextColor
  }, header), headerButton || react_1.default.createElement(greeting_scenario_node_component_1.GreetingScenarioNodeHeaderButton, {
    backgroundColor: bodyBackColor
  })), react_1.default.createElement(greeting_scenario_node_styles_1.StyledBodyDiv, {
    backgroundColor: footerBackColor
  }, react_1.default.createElement(greeting_scenario_node_component_1.OpeningTimeDisplay, {
    openingTimeStr: openingTimes[new Date().getDay()]
  }), waitingTime.isEnabled && react_1.default.createElement(greeting_scenario_node_component_1.WaitingTimeDisplay, {
    waitingTimeStr: waitingTime.status
  }), react_1.default.createElement(greeting_scenario_node_component_1.TimeTableDisplay, {
    timeTable: timeTable
  }), footerButton || react_1.default.createElement(greeting_scenario_node_footer_button_container_1.default, null), react_1.default.createElement(greeting_scenario_node_styles_1.StyledReloadP, null, "\u66F4\u65B0\u3059\u308B"))));
};

exports.default = GreetingScenarioNodeTemplate;